import React, { useEffect, useMemo } from 'react';

// DEPENDENCIES
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

// HELPERS
import { useDealTasks } from '../helpers/DealTasksProvider';
import usePrevious from 'helpers/usePrevious';

// FUNCTIONS
import { doCallback } from 'functions';

// GLOBAL COMPONETNS
import Table from 'parts/table/Table';

// MAIN COMPONENT
const TasksBadge = ({ value = 0, row: { original, index } = {}, resizeRow }) => {
  // HOOKS
  const { toggleExpanded, tasksCount, setTaskCount } = useDealTasks() || {};

  // MEMOS
  const count = useMemo(() => tasksCount[index], [tasksCount, index]);

  // CALLBACKS
  const handleClick = useAccordionButton(original.sales_id, () => {
    doCallback(resizeRow);
    doCallback(toggleExpanded, original.sales_id);
  });

  const prevValue = usePrevious(value);

  // EFFECTS
  // Initialize counts
  useEffect(() => {
    if (tasksCount[index] === undefined || prevValue !== value) setTaskCount(index, value);
  }, [index, setTaskCount, tasksCount, prevValue, value]);

  // RENDER
  return (
    <Table.Badge badge="accent" onClick={handleClick} className="px-2">
      {count}
    </Table.Badge>
  );
};

// EXPORT
export default TasksBadge;
